export const ukCities = [
  "Aberdeen",
  "Armagh",
  "Bangor (Wales)",
  "Bangor (Northern Ireland)",
  "Bath",
  "Belfast",
  "Birmingham",
  "Bradford",
  "Brighton and Hove",
  "Bristol",
  "Cambridge",
  "Canterbury",
  "Cardiff",
  "Carlisle",
  "Chelmsford",
  "Chester",
  "Chichester",
  "City of London",
  "City of Westminster",
  "Colchester",
  "Coventry",
  "Derby",
  "Derry",
  "Doncaster",
  "Dundee",
  "Dunfermline",
  "Durham",
  "Edinburgh",
  "Ely",
  "Exeter",
  "Glasgow",
  "Gloucester",
  "Hereford",
  "Inverness",
  "Kingston upon Hull",
  "Lancaster",
  "Leeds",
  "Leicester",
  "Lichfield",
  "Lincoln",
  "Lisburn",
  "Liverpool",
  "Manchester",
  "Milton Keynes",
  "Newcastle upon Tyne",
  "Newport",
  "Newry",
  "Norwich",
  "Nottingham",
  "Oxford",
  "Perth",
  "Peterborough",
  "Plymouth",
  "Portsmouth",
  "Preston",
  "Ripon",
  "Salford",
  "Salisbury",
  "Sheffield",
  "Southampton",
  "Southend-on-Sea",
  "St Albans",
  "St Asaph",
  "St Davids",
  "Stirling",
  "Stoke-on-Trent",
  "Sunderland",
  "Swansea",
  "Truro",
  "Wakefield",
  "Wells",
  "Winchester",
  "Wolverhampton",
  "Worcester",
  "Wrexham",
  "York"
];




// utils/languages.js

export const languages = [
  "English",
  "Spanish",
  "French",
  "German",
  "Italian",
  "Portuguese",
  "Dutch",
  "Russian",
  "Polish",
  "Swedish",
  "Norwegian",
  "Danish",
  "Finnish",
  "Greek",
  "Turkish",
  "Arabic",
  "Mandarin Chinese",
  "Cantonese Chinese",
  "Japanese",
  "Korean",
  "Hindi",
  "Bengali",
  "Punjabi",
  "Urdu",
  "Persian (Farsi)",
  "Hebrew",
  "Thai",
  "Vietnamese",
  "Malay",
  "Indonesian",
  "Tagalog (Filipino)",
  "Czech",
  "Slovak",
  "Hungarian",
  "Romanian",
  "Ukrainian",
  "Lithuanian",
  "Latvian",
  "Estonian",
  "Serbian",
  "Croatian",
  "Bosnian",
  "Slovenian",
  "Macedonian",
  "Albanian",
  "Irish Gaelic",
  "Scottish Gaelic",
  "Welsh",
  "Icelandic",
  "Afrikaans",
  "Swahili",
  "Zulu",
  "Xhosa",
];
